{
  "longPressMessage": "長按或按 Alt+向下鍵以開啟功能表"
}
